import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface VersionUpdateData {
  currentVersion: string;
  newVersion: string;
  isRollback?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class VersionUpdateService {
  private readonly versionUpdateSubject = new Subject<VersionUpdateData>();
  public versionUpdate$ = this.versionUpdateSubject.asObservable();

  private readonly logger = {
    log: (message: string, data?: unknown) => {
      console.log(`[VersionUpdateService] ${message}`, data || '');
    },
    warn: (message: string, data?: unknown) => {
      console.warn(`[VersionUpdateService] ${message}`, data || '');
    },
    error: (message: string, data?: unknown) => {
      console.error(`[VersionUpdateService] ${message}`, data || '');
    }
  };

  showUpdatePrompt(data: VersionUpdateData): void {
    this.versionUpdateSubject.next(data);
  }

  async getCurrentVersion(buildTimeVersion: string): Promise<string> {
    try {
      const response = await fetch('/assets/version.json?ts=' + Date.now(), {
        cache: 'no-cache'
      });

      if (response.ok) {
        const data = await response.json();
        return data.version || buildTimeVersion;
      }
    } catch {
      this.logger.warn(
        'Failed to load runtime version, using build-time version'
      );
    }

    return buildTimeVersion;
  }

  performHardRefresh(): void {
    if ('caches' in window) {
      caches
        .keys()
        .then((names) => Promise.all(names.map((name) => caches.delete(name))));
    }

    window.onbeforeunload = null;

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('_t', Date.now().toString());

      window.open(url.toString(), '_self');
    } catch (error) {
      this.logger.error('Failed to parse current URL for hard refresh:', error);

      this.logger.warn('Falling back to simple page reload');
      window.open(window.location.href, '_self');
    }
  }
}
